import React from "react";

export type KeyValueValueType = string | React.ReactNode;

/** Layout modes for `KeyValueList` rows. */
export const KeyValueListLayout = {
  DEFAULT: "default",
  COMPACT: "compact",
} as const;
export type KeyValueListLayoutType =
  (typeof KeyValueListLayout)[keyof typeof KeyValueListLayout];

export type KeyValuePair = {
  title: string | React.ReactNode;
  value?: KeyValueValueType;
  description?: string;
};

export type KeyValuePairList = KeyValuePair[];

export type KeyValueListProps = {
  data?: KeyValuePairList;
  variant?: "zebra" | "shaded" | "border" | "plain";
  color?: "active" | "placeholder" | "neutral" | "light";
  maxRowCount?: number;
  applySmallFont?: boolean;
  className?: string;
  isLoading?: boolean;
  /** Align values to the left or right. Defaults to right. */
  valueAlignment?: "left" | "right";
  /**
   * `compact` lays out all rows in one grid: the label column is as wide as the
   * longest label so values share a common start edge and fill that column.
   * `default` keeps the legacy 50% / 50% flex columns per row.
   */
  layout?: KeyValueListLayoutType;
};
